import { Component, OnInit } from '@angular/core';
import { MoveObjectEventService } from '../../services/move-object-event.service';
import { UnsavedSceneService } from '../../services/unsaved-scene.service'
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { ModalController } from '@ionic/angular';
import { VrEventTriggerService } from '../../services/vr-event-trigger.service';
import { VrEventTypeService } from '../../services/vr-event-type.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { VrEvent } from 'src/app/models/vr-events/VrEvent';
import { VrEventAssetRelation } from 'src/app/models/vr-events/VrEventAssetRelation';
import { VrEventService } from 'src/app/services/vr-event.service';

@Component({
  selector: 'app-add-events-modal',
  templateUrl: './add-events-modal.page.html',
  styleUrls: ['./add-events-modal.page.scss'],
})
export class AddEventsModalPage implements OnInit {
  public displayMediaEvents: boolean = true;

  constructor(
    public moveObjectEventService: MoveObjectEventService,
    public unsavedSceneService: UnsavedSceneService,
    public VrEventTypeService: VrEventTypeService,
    public VrEventTriggerService: VrEventTriggerService,
    public modalController: ModalController,
    public assetTypeService: AssetTypeService,
    public VrEventService: VrEventService
  ) { }

  ChangeSelectedTab(selectedTab) {
    if (selectedTab == "asset") {
      this.displayMediaEvents = true;
    }
    else {
      this.displayMediaEvents = false;
    }
  }
  ngOnInit() {
    this.displayMediaEvents = true;
    // REMOVE ALL SCENE EVENTS ON INIT
    if (!this.VrEventService.isAssetEvent) {
      var videoSphere = document.querySelector('#sky');
      for (var eventIndex = 0; eventIndex < this.VrEventService.getActiveSceneEvents().length; eventIndex++) {
        videoSphere.removeAttribute('scene-event__' + eventIndex);
      }
    }
  }

  cancelModal() {
    if (!this.VrEventService.isAssetEvent) {
      var videoSphere = document.querySelector('#sky');
      for (var eventIndex = 0; eventIndex < this.VrEventService.getActiveSceneEvents().length; eventIndex++) {
        this.setUpSceneEvent(this.VrEventService.scene, eventIndex);
      }
    }
    this.modalController.dismiss();
  }

  setIsSaved(isSaved) {
    this.unsavedSceneService.setHasSceneBeenSaved(isSaved);
  }

  setUpSceneEvent(scene: Scene, eventIndex: number) {
    var videoSphere = document.querySelector('#sky');
    videoSphere.setAttribute('scene-event__' + eventIndex,
      {
        'sceneId': scene.sceneId,
        'linkedAssetId': scene.events[eventIndex].linkedContentId,
        'eventTypeId': scene.events[eventIndex].eventTypeId,
        'timeOfEvent': scene.events[eventIndex].timeOfEvent,
      });
  }

  getActiveAssetsInScene() {
    return this.VrEventService.getActiveAssetsInScene();
  }
}
